var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,2.5m10.9167,9.66667h-0.658l-0.234,-0.225c0.817,-0.95,1.309,-2.183,1.309,-3.525c0,-2.992,-2.425,-5.417,-5.417,-5.417c-2.992,0,-5.417,2.425,-5.417,5.417c0,2.992,2.425,5.417,5.417,5.417c1.342,0,2.575,-0.492,3.525,-1.309l0.225,0.234v0.658l4.167,4.158l1.241,-1.241l-4.158,-4.167zm-5,0c-2.075,0,-3.75,-1.675,-3.75,-3.75c0,-2.075,1.675,-3.75,3.75,-3.75c2.075,0,3.75,1.675,3.75,3.75c0,2.075,-1.675,3.75,-3.75,3.75z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSvg);
export default __webpack_public_path__ + "static/media/SearchSvg.df034d99.svg";
export { ForwardRef as ReactComponent };